module.exports = __webpack_public_path__ + "../static/img/url-html-icon.47758daf.png";